import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import * as urlParser from 'url-parse';
import * as qs from 'qs';
import Tooltip from '@material-ui/core/Tooltip';
import { AppStyles } from '../styles/AppTheme';
import moment from 'moment';
import { AppConfig } from '../AppConfig';
import { Controller } from '../common/Controller';

export class ParkingHelper {
  static processParkingStats(parkingEntry, parkingEntryTotal, statAdjust, eventCompleteList) {
    let parkingOutToday = null, parkingInToday = null;
    let parkingOutTotal = null, parkingInTotal = null;
    for (const e of eventCompleteList) {
      if (e.statInfo && e.statInfo.IN_TODAY !== undefined && parkingInToday === null) {
        parkingInToday = e.statInfo.IN_TODAY
      }
      if (e.statInfo && e.statInfo.OUT_TODAY !== undefined && parkingOutToday === null) {
        parkingOutToday = e.statInfo.OUT_TODAY
      }
      if (e.statInfo && e.statInfo.IN_TOTAL !== undefined && parkingInTotal === null) {
        parkingInTotal = e.statInfo.IN_TOTAL
      }
      if (e.statInfo && e.statInfo.OUT_TOTAL !== undefined && parkingOutTotal === null) {
        parkingOutTotal = e.statInfo.OUT_TOTAL
      }
    }

    if (parkingInToday !== null) {
      parkingEntry.IN = parkingInToday
    }
    if (parkingOutToday !== null) {
      parkingEntry.OUT = parkingOutToday
    }
    if (parkingInTotal !== null) {
      parkingEntryTotal.IN_TOTAL = parkingInTotal
    }
    if (parkingOutTotal !== null) {
      parkingEntryTotal.OUT_TOTAL = parkingOutTotal
    }
    parkingEntry.PARKED = parkingEntryTotal.IN_TOTAL - parkingEntryTotal.OUT_TOTAL + statAdjust


    return {
      parkingEntry: parkingEntry,
      parkingEntryTotal: parkingEntryTotal
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/ParkingHelper.js